import { eventRequestHandler, EVENTS } from '@edreamsodigeo/frontend-seats';
const postBookingSeats = {
  eventRequestHandler,
  EVENTS
};
export default postBookingSeats;